const paths = {
  homePage: '/',
  kindergartenServices: '/kindergarten-services',
  govServices: '/gov-services',
  checkQueueNumber: '/check-queue-number',
  queueApplications: '/queue-applications',
  bulletinOpenPlaces: '/bulletin-open-places',
  bulletinOpenPlacesKq: '/bulletin-open-places/kqId=:kqId',
  bulletinOpenPlacesVoucher: '/bulletin-open-places/voucherId=:voucherId',
  kindergartenReestr: '/kindergarten-reestr',
  kindergartenReestrByVoucherId:
    '/kindergarten-reestr/voucherId=:voucherId&serviceProviderId=:serviceProviderId',
  kindergartenReestrByVoucherIdAndChangeDuo:
    '/kindergarten-reestr/voucherId=:voucherId&serviceProviderId=:serviceProviderId?isChangeDuo=1',
  kindergartenReestrByKindergantenId: '/kindergarten-reestr/id=:id',
  createRequestPage: '/services/create/:metadataKey',
  accountPage: '/account',
  requestsPage: '/requests',
  completedRequestsPage: '/completed-requests',
  accountSettingsPage: '/account/settings',
  attachChildWithParentPage: '/account/attach',
  viewRequestFormPage: '/view/:from/:id',
  instructionsPage: '/instructions',
  videoInstructionsPage: '/video-instructions',
  faqPage: '/faq',
  kindergartenApplications: '/kindergarten-applications',
  kindergartenAppointments: '/kindergarten-appointments',
  kindergartenNotifications: '/kindergarten-notifications',
  kindergartenAccompaniments: '/kindergarten-accompaniments',
  marketAndroidPage: '/market/android',
  voucherApplications: '/voucher-applications',
  voucherAppointments: '/voucher-appointments',
  voucherWaitingList: '/voucher-waitingList',
  voucherNotifications: '/voucher-notifications',
  voucherAgreements: '/voucher-agreements'
};

export default paths;
